<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="课程">-->
<!--                  <el-input  v-model="queryForm.courseId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="订单编号">-->
<!--                  <el-input  v-model="queryForm.orderNumber"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="订单价格">-->
<!--                  <el-input  v-model="queryForm.orderPrice"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="订单状态">
<!--                  <el-input style="width: 177px;" v-model="queryForm.orderStatus"></el-input>-->
                  <el-select style="width: 177px;" placeholder="请选择" size="small" v-model="queryForm.orderStatus" clearable>
                      <el-option v-for="item in statusList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="支付时间">-->
<!--                  <el-input  v-model="queryForm.payTime"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseOrderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addEduCourseOrder"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editEduCourseOrder(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseOrder(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEduCourseOrderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseOrderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="courseId"-->
<!--        label="课程"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderNumber"
        label="订单编号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderPrice"
        label="订单价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderStatus"
        label="订单状态"
        width="180"
      >
          <template slot-scope="scope">
              {{returnStatus(scope.row.orderStatus)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payTime"
        label="支付时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkEduCourseOrder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editEduCourseOrder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteEduCourseOrder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseOrderStates[eduCourseOrderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduCourseOrder"
          ref="eduCourseOrderForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="课程"-->
<!--            prop="courseId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseOrder.courseId"-->
<!--              :disabled="eduCourseOrderState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="订单编号"
            prop="orderNumber"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseOrder.orderNumber"
              :disabled="eduCourseOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单价格"
            prop="orderPrice"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseOrder.orderPrice"
              :disabled="eduCourseOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单状态"
            prop="orderStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="eduCourseOrder.orderStatus"-->
<!--              :disabled="eduCourseOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                size="small"
                style="width: 177px;"
                v-model="eduCourseOrder.orderStatus"
                :disabled="eduCourseOrderState == 'check'"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseOrder.userId"-->
<!--              :disabled="eduCourseOrderState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName" :disabled="eduCourseOrderState == 'check'"
                           labelValue="id" title="选择用户" :value="eduCourseOrder.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="支付时间"
            prop="payTime"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseOrder.payTime"
              :disabled="eduCourseOrderState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseOrderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseOrderList();
                    this.getEduCourseOrderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseOrderList();
                    this.getEduCourseOrderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     courseId: '', //课程
                     orderNumber: '', //订单编号
                     orderPrice: '', //订单价格
                     orderStatus: '', //订单状态
                     userId: '', //用户
                     payTime: '', //支付时间
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseOrderState: 'add',
                eduCourseOrderStates: {
                    add: '新建订单',
                    check: '查看订单',
                    edit: '修改订单'
                },

                multipleSelection: [],
                eduCourseOrderList: [],
                eduCourseOrder: {
                    id: '', //ID
                    courseId: '', //课程
                    orderNumber: '', //订单编号
                    orderPrice: '', //订单价格
                    orderStatus: '', //订单状态
                    userId: '', //用户
                    payTime: '', //支付时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    courseId: [{ required: true, message: '课程不能为空', trigger: 'blur' }],
                    orderNumber: [{ required: true, message: '订单编号不能为空', trigger: 'blur' }],
                    orderPrice: [{ required: true, message: '订单价格不能为空', trigger: 'blur' }],
                    orderStatus: [{ required: true, message: '订单状态不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    payTime: [{ required: true, message: '支付时间不能为空', trigger: 'blur' }],
                },
                statusList: [],
            };
        },
        created() {
        this.getEunm();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getEunm(){
                get('/edu/utils/getEnum?enumType=order_status').then(res => {
                    this.statusList = res.enumList;
                })
            },
            returnStatus(key){
                for (let statusListElement of this.statusList) {
                    if(statusListElement.key == key){
                        return statusListElement.value
                    }
                }
            },
            init(id){
                this.queryForm.courseId = id;
                this.eduCourseOrder.courseId = id;
                this.getEduCourseOrderList();
            },
            resetEduCourseOrderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseOrderList = [];
            },
            getValueUser(value){
                this.eduCourseOrder.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            resetDialog() {
                this.eduCourseOrderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      courseId: this.queryForm.courseId, //课程
                      orderNumber: '', //订单编号
                      orderPrice: '', //订单价格
                      orderStatus: '', //订单状态
                      userId: '', //用户
                      payTime: '', //支付时间
                };
                this.getEduCourseOrderList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseOrder = {
                      id: '', //ID
                      courseId: this.eduCourseOrder.courseId, //课程
                      orderNumber: '', //订单编号
                      orderPrice: '', //订单价格
                      orderStatus: '', //订单状态
                      userId: '', //用户
                      payTime: '', //支付时间
                };
            },
            submitForm() {
                if (this.eduCourseOrderState == 'add') {
                    this.$refs.eduCourseOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/courseorder/add`,{ ...this.eduCourseOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseOrderState == 'edit') {
                    this.$refs.eduCourseOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/courseorder/edit`,{ ...this.eduCourseOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseOrder() {
                this.showDialog = true;
                this.eduCourseOrderState = 'add';
            },
            checkEduCourseOrder(eduCourseOrderId) {
                console.log(eduCourseOrderId);
                this.currentEduCourseOrderId = eduCourseOrderId;

                this.getEduCourseOrderById();
                this.showDialog = true;
                this.eduCourseOrderState = 'check';
            },
            editEduCourseOrder(eduCourseOrderId) {
                console.log('eduCourseOrder', eduCourseOrderId);
                if (eduCourseOrderId) {
                    this.currentEduCourseOrderId = eduCourseOrderId;
                    this.getEduCourseOrderById();
                } else {
                    this.eduCourseOrder = { ...this.eduCourseOrder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseOrderState = 'edit';
            },
            deleteEduCourseOrder(eduCourseOrderId) {
                let ids = '';
                if (eduCourseOrderId) {
                    ids = eduCourseOrderId;
                } else {
                    ids = this.multipleSelection.map((eduCourseOrder) => eduCourseOrder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/courseorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseOrderList();
                                this.getEduCourseOrderList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseOrderList() {
                this.resetEduCourseOrderList();
                this.getEduCourseOrderList();
            },
            getEduCourseOrderList(query = {}) {
                this.loading = true;
                get(`/edu/courseorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseOrderList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseOrderById() {
                get(`/edu/courseorder/get`,{ id: this.currentEduCourseOrderId }).then((res) =>{
                    if(res.success){
                      this.eduCourseOrder = { ...this.eduCourseOrder, ...res.eduCourseOrder };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseOrderList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/courseorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/courseorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/courseorder/importData`,formData);
              this.refreshEduCourseOrderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseOrderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseOrderList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>